(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lifeline-purchase"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
    const link=event.target.closest('[data-lifeline-invoice]');
    if(!link)return;
    const quantity=document.getElementById('Quantity-'+link.dataset.sectionId+'-'+link.dataset.productId);
    const count=Math.max(1,Math.floor(Number(quantity&&quantity.value)||1));
    const url=new URL(link.href,window.location.origin);
    url.searchParams.set('quantity',String(count));
    link.href=url.toString();
  });
  } catch(e) { console.error(e); }
})();

})();
